import React from 'react';
import FormLogin from '../../../components/login/form-login/index';

export default function TelaLogin() {
    return (
        <FormLogin />
    )
}